import { FormControl, FormGroup } from '@angular/forms';

export type AdminCartSettingsFormControls = {
  deleteCartAfterCheckout: FormControl<boolean | null>;
};

export class AdminCartSettingsFormData {
  public constructor(
    private readonly data: {
      deleteCartAfterCheckout: boolean;
    },
  ) {}

  public get deleteCartAfterCheckout(): boolean {
    return this.data.deleteCartAfterCheckout;
  }
}

/* prettier-ignore */
export type AdminCartSettingsFormGroup = FormGroup<AdminCartSettingsFormControls>;
